export function today(requiredDate) {
  let date = requiredDate ? new Date(requiredDate) : new Date();

  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");
  let year = date.getFullYear().toString();
  let currentDate = `${year}-${month}-${day}`;

  return currentDate;
}
